import { Button } from '@shared/components/Button';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { getTestId } from '@shared/util/getTestId';
import { i18n } from '@shared/util/i18n';

interface AddMoreButtonProps {
  onPress: VoidFunction;
  component: API.AnyComponent;
  label?: string;
}

export function AddMoreButton({
  onPress,
  component,
  label = i18n('card.blocks.cardsInput.addMore'),
}: AddMoreButtonProps) {
  return (
    <View row centerVertically marginLeft={-1.5} paddingVertical={0.5}>
      <Button
        variant="ghost"
        size="medium"
        icon="plus-circle"
        iconGridSize={3.25}
        label={label}
        onClick={onPress}
        testID={getTestId('add-more-button', component.id)}
      />
    </View>
  );
}
